import styled from 'styled-components'
import { Box } from 'rebass/styled-components'
// This is a simple wrapper to ensure all form elements have a consistent height
export default styled(Box)`
  display: inline-block;
  min-height: 4em;
`
